import * as THREE from 'three'
import type { CharacterSnapshot } from '@sharefe/share3d-engine'

export const OUT_OF_BOUNDS_Z = -25

export interface OutOfBoundsResetAdapter {
  setFloorPoint(point: THREE.Vector3): CharacterSnapshot
  getSnapshot(): CharacterSnapshot
}

export function isPlayerOutOfBounds(
  snapshot: CharacterSnapshot,
  threshold = OUT_OF_BOUNDS_Z,
): boolean {
  return (
    snapshot.capsule.start.z <= threshold ||
    snapshot.capsule.end.z <= threshold
  )
}

export function resetPlayerOutOfBounds(
  snapshot: CharacterSnapshot,
  adapter: OutOfBoundsResetAdapter,
  spawnFloorPoint: THREE.Vector3,
  onReset?: (snapshot: CharacterSnapshot) => void,
): CharacterSnapshot {
  if (!isPlayerOutOfBounds(snapshot)) {
    return snapshot
  }

  adapter.setFloorPoint(spawnFloorPoint)
  const resetSnapshot = adapter.getSnapshot()
  onReset?.(resetSnapshot)
  return resetSnapshot
}
